import { Columns3, Tags } from 'lucide-react';
import { salvarVisao, type Visao } from './cores';

/**
 * Duas maneiras de ler a mesma distribuição por cor: uma coluna por cor, como
 * na planilha que a Condusvale usa há anos, ou as cores resumidas numa célula
 * só, que cabe melhor quando a cotação tem muitas.
 */
export default function AlternadorDeVisao({
  visao,
  aoTrocar,
}: {
  visao: Visao;
  aoTrocar: (visao: Visao) => void;
}) {
  const trocar = (nova: Visao) => {
    salvarVisao(nova);
    aoTrocar(nova);
  };

  const estilo = (alvo: Visao) =>
    [
      'inline-flex items-center gap-xs px-sm py-xs text-[12px] font-bold rounded transition-colors',
      visao === alvo ? 'bg-surface text-ink shadow-sm' : 'text-muted hover:text-ink',
    ].join(' ');

  return (
    <div
      role="group"
      aria-label="Como mostrar a distribuição por cor"
      className="inline-flex gap-xs rounded-md border border-border bg-surface-subtle p-[3px]"
    >
      <button
        type="button"
        onClick={() => trocar('colunas')}
        aria-pressed={visao === 'colunas'}
        className={estilo('colunas')}
      >
        <Columns3 size={14} aria-hidden="true" />
        Uma coluna por cor
      </button>
      <button
        type="button"
        onClick={() => trocar('resumo')}
        aria-pressed={visao === 'resumo'}
        className={estilo('resumo')}
      >
        <Tags size={14} aria-hidden="true" />
        Resumidas
      </button>
    </div>
  );
}
